(function() {
    let scrolledHeight = 0;

    function burgerListener() {
        let burger = document.querySelector('.menu-toggle');

        if( burger ) {
            burger.addEventListener('click', function() {
                menuToggle();
            });
        }
    }
    function menuToggle() {
        let burger = document.querySelector('.menu-toggle');
        let topBar = document.querySelector('.topBar');

        if( !burger.classList.contains('is-active') ) {
            burger.classList.add('is-active');
            topBar.classList.add('is-opened');
        } else {
            burger.classList.remove('is-active');
            topBar.classList.remove('is-opened');
        }
    }

    function setMenuScrolledClass() {
        const menuContainer = document.querySelector('.topBar');
        const body = document.querySelector('body');

        if( scrolledHeight > 150 ) {
            menuContainer.classList.add('is-scrolled');
            body.classList.add('scrolled');
        } else {
            menuContainer.classList.remove('is-scrolled');
            body.classList.remove('scrolled');
        }


        if( scrolledHeight > (window.innerHeight * 0.25) ) {
            body.classList.add('show-page-navigation');
        } else {
            body.classList.remove('show-page-navigation');
        }
    }

    function switchLanguage() {
        let btn = document.querySelector('[data-switchLanguage]');
        let menu = document.querySelector('.langSwitcher--list');

        if( btn ) {
            btn.addEventListener('click', function() {
                menu.classList.toggle("active");
                this.classList.toggle("active");
            });
        }
    }

    function setMenuItemsClickAction() {
        if (window.innerWidth < 1200 ) {
            let buttons = document.querySelectorAll('.menu-item-has-children');

            buttons.forEach(function(item) {
                item.addEventListener('click', function(e) {

                    if( e.target == this ) {
                        let subMenu = item.querySelector('.sub-menu');
                        item.classList.toggle('opened');
                        if (subMenu) {
                            e.preventDefault();
                            subMenu.classList.toggle('opened');
                        }
                    }
                });
            });
        }
    }

    function setMenuHoverAction() {
        let topMenu = document.querySelector('.mainMenuContainer');
        let topMenuFirstElem = document.querySelectorAll('.mainMenuContainer > ul > li > a');

        if( topMenuFirstElem.length ) {
            topMenuFirstElem.forEach(function(item) {
                item.addEventListener('mouseover', function() {
                    let active = document.querySelector('.sub-menu.opened');
                    let activeElem = document.querySelector('.menu-item a.opened');
                    let submenu = item.nextElementSibling;

                    if(active) {
                        active.classList.remove('opened');
                    }
                    if( activeElem ) {
                        activeElem.classList.remove('opened');
                    }
                    if( submenu && submenu.classList.contains('sub-menu') ) {
                        submenu.classList.add('opened');
                    }
                    item.classList.add('opened')
                });
            });
        }

        if( topMenu ) {
            topMenu.addEventListener('mouseleave', function() {
                let active = document.querySelector('.sub-menu.opened');
                let activeElem = document.querySelector('.menu-item a.opened');

                if(active) {
                    active.classList.remove('opened');
                }
                if( activeElem ) {
                    activeElem.classList.remove('opened');
                }
            });
        }
    }

    window.addEventListener('load', function() {
        burgerListener();
        switchLanguage();
        setMenuItemsClickAction();
        setMenuHoverAction();
    });

    window.addEventListener('scroll', function(e) {
        setMenuScrolledClass();
        scrolledHeight = window.pageYOffset || document.documentElement.scrollTop;
    });
})()


//////////////////
// WEBPACK FOOTER
// ./js/top-menu.js
// module id = 8
// module chunks = 0